module.exports = __webpack_public_path__ + "img/task_nodata.fa3bfd10.png";